import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { FilterCreditHistory, FilterUseProducts } from 'src/app/models/relatorio';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ExcelService, WorksheetData } from 'src/app/shared/services/excel.service';
import { PdfData, PdfService } from 'src/app/shared/services/pdf.service';
import {saveAs} from 'file-saver';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { FormControl } from '@angular/forms';
import { MASKS } from 'ng-brazil';
import { DepositoService } from 'src/app/services/deposito.service';
import { ReciboIntencaoDeposito } from 'src/app/models/recibo-intencao-deposito';

@Component({
  selector: 'app-credito-relatorio',
  templateUrl: './credito-relatorio.component.html',
  styleUrls: ['./credito-relatorio.component.css']
})
export class CreditoRelatorioComponent implements OnInit {

  constructor(
    private relatorioService: RelatorioService,
    private depositoService: DepositoService,
    private authenticationService: AuthenticationService,
    private alertService: NewAlertService,
    private modalService: NgbModal,
    public datepipe: DatePipe
  ) { }

  public MASKS = MASKS;
  public currentUser: Auth;
  public filtro = new FilterCreditHistory(null,null,null,null,null,null);

  public reciboIntencaoDeposito: ReciboIntencaoDeposito = null;
  
  public paymentTypeCtrl: FormControl = new FormControl();
  public purchaseCtrl: FormControl = new FormControl();
  public valueCtrl: FormControl = new FormControl();
  public statusCtrl: FormControl = new FormControl();
  
  public dataInicio = new Date();
  public dataFim = new Date();
  public dataMaxima = new Date();
  
  public creditos: any;
  public filtroOn: boolean = false;
  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;
  collumnName = "";
  queryDate: Date;

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;

    this.dataInicio.setDate(this.dataInicio.getDate()-90);
    this.filtro.dateStart = this.dataInicio;
    this.filtro.dateEnd = this.dataFim;

    this.carregarRelatorio(1);
  }

  carregarRelatorio(page){
    this.currentPage = page;
    this.relatorioService.getCreditHistory(this.currentUser.token.assignorGuid,(page-1),+this.showItem,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.creditos = response.result.creditHistory;
        this.totalItems = response.result.total;
        this.queryDate = new Date();
      }
    });
  } 

  showItemChanged(event) {
    this.showItem = event;
    this.carregarRelatorio(1);
  }

  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  setPeriod(inicio,date: Date){
    if(inicio){
      this.filtro.dateStart = date;
      this.dataMaxima = new Date(date.getFullYear(), date.getMonth(), date.getDate()+90);
      if (this.filtro.dateEnd >= this.dataMaxima){
        this.filtro.dateEnd = this.dataMaxima;
      } else if (this.filtro.dateEnd < this.filtro.dateStart){
        this.filtro.dateEnd =  this.filtro.dateStart;
      }
    } else {
      this.filtro.dateEnd = date;
    }
  }
  
  applyFilter() {
    this.filtro.type = this.paymentTypeCtrl.value
    this.filtro.value = this.valueCtrl.value ? +this.valueCtrl.value.replace('R$', '').replace(/\./g, '').replace(',', '.').trim() : null;
    this.filtro.stauts = this.statusCtrl.value;
    this.filtro.purchaseId = this.purchaseCtrl.value;

    if(
      this.filtro.dateStart == this.dataInicio &&
      this.filtro.dateEnd == this.dataFim &&
      this.filtro.value == null &&
      this.filtro.stauts == null &&
      this.filtro.purchaseId == null
    ){
      this.filtroOn = false;
      this.carregarRelatorio(1);
    } else {
      this.filtroOn = true;
      this.carregarRelatorio(1);
    }
  }

  deleteFilter(){
    this.filtro.dateStart = this.dataInicio;
    this.filtro.dateEnd = this.dataFim;
    this.dataMaxima = this.dataFim;
    this.filtro.value = null;
    this.filtro.stauts = null;
    this.filtro.purchaseId = null;

    this.paymentTypeCtrl.setValue(null);
    this.valueCtrl.setValue(null);
    this.statusCtrl.setValue(null);
    this.purchaseCtrl.setValue(null);

    this.filtroOn = false;

    this.carregarRelatorio(1);
  }
  
  exportExtractExcel(){
    var result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const excelService = new ExcelService();
    const worksheets = new Array<WorksheetData>();
    const ws = new WorksheetData();
    ws.worksheetTitle = 'relatorio_creditos_' + date[2] + '-' + date[1] + '-' + date[0];
    ws.worksheetHeaders = ['Código','Referência','Cód. Recarga','Tipo','Status','Valor','Emissão','Vencimento','Processamento','Cancelamento'];
    ws.WorksheetRows = [];
    // /*
    this.relatorioService.getCreditHistory(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.creditHistory;
      
        result.forEach((r) => {
          const lr = new Array<string>();
          lr.push(r.depositId);
          lr.push(r.reference);
          lr.push(r.purchaseId);
          lr.push(r.paymentType );
          lr.push(r.status );
          lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
          lr.push(this.datepipe.transform(r.release, 'dd/MM/yyyy HH:mm'));
          lr.push(this.datepipe.transform(r.due, 'dd/MM/yyyy'));
          lr.push(this.datepipe.transform(r.processing, 'dd/MM/yyyy HH:mm'));
          lr.push(this.datepipe.transform(r.cancellation, 'dd/MM/yyyy'));
          ws.WorksheetRows.push(lr);
        });

        worksheets.push(ws);

        let filter = 'Data inicio: ' + this.datepipe.transform(this.filtro.dateStart, 'dd/MM/yyyy') + ' - Data fim: ' + this.datepipe.transform(this.filtro.dateEnd, 'dd/MM/yyyy');
        filter += (this.filtroOn && this.filtro.type)  ? ' - Tipo: ' + this.filtro.type: '';
        filter += (this.filtroOn && this.filtro.stauts)  ? ' - Stauts: ' + this.filtro.stauts : '';
        filter += (this.filtroOn && this.filtro.value)  ? ' - Valor: ' + this.filtro.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '';
        filter += (this.filtroOn && this.filtro.purchaseId)  ? ' - Cód. Recarga: ' + this.filtro.purchaseId : '';

        excelService.generateExcelReport('Histório de créditos', worksheets, filter).xlsx
        .writeBuffer().then((data) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          saveAs(blob, ws.worksheetTitle + '.xlsx');
        });

      }
    },
    error => {
      this.alertService.error('Ocorreu um erro ao paginar relatorio');
    });
    // */
  }

  exportExtractPdf(){
    let result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const pdfData = new PdfData();
    pdfData.PdfTitle = 'relatorio_creditos_' + date[2] + '-' + date[1] + '-' + date[0];
    pdfData.PdfHeaders = ['Código','Referência','Cód. Recarga','Tipo','Status','Valor','','Emissão','Vencimento','Processamento','Cancelamento'];
    pdfData.PdfRows = [];

    this.relatorioService.getCreditHistory(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.creditHistory;

        result.forEach((r) => {
          const lr = new Array<string>();
          lr.push(r.depositId);
          lr.push(r.reference);
          lr.push(r.purchaseId);
          lr.push(r.paymentType);
          lr.push(r.status);
          lr.push('R$');
          lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
          lr.push(this.datepipe.transform(r.release, 'dd/MM/yyyy HH:mm'));
          lr.push(this.datepipe.transform(r.due, 'dd/MM/yyyy'));
          lr.push(this.datepipe.transform(r.processing, 'dd/MM/yyyy HH:mm'));
          lr.push(this.datepipe.transform(r.cancellation, 'dd/MM/yyyy'));
          pdfData.PdfRows.push(lr);
        });

        let filter = 'Data inicio: ' + this.datepipe.transform(this.filtro.dateStart, 'dd/MM/yyyy') + ' - Data fim: ' + this.datepipe.transform(this.filtro.dateEnd, 'dd/MM/yyyy');
        filter += (this.filtroOn && this.filtro.type)  ? ' - Tipo: ' + this.filtro.type: '';
        filter += (this.filtroOn && this.filtro.stauts)  ? ' - Stauts: ' + this.filtro.stauts : '';
        filter += (this.filtroOn && this.filtro.value)  ? ' - Valor: ' + this.filtro.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '';
        filter += (this.filtroOn && this.filtro.purchaseId)  ? ' - Cód. Recarga: ' + this.filtro.purchaseId : '';

        const pdfService = new PdfService();
        pdfService.generatePdfReport('Histório de créditos',pdfData,filter,this.datepipe.transform(this.queryDate, 'dd/MM/yyyy HH:mm:ss'),true).getBlob((blob) => {
          saveAs(blob, pdfData.PdfTitle + '.pdf');
        });

      } else {
        this.alertService.error(response.message);
      }
    },
    error => {
      this.alertService.error(
        'Ocorreu um erro ao paginar o relatorio'
      );
    });
  }

  showVisualizarReciboIntencaoDeposito(content: any, intencaoDepositoGuid: string) {
    // chamar api
    this.depositoService.getRecibo(intencaoDepositoGuid).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.reciboIntencaoDeposito = response.result;
          this.modalService.open(content, { centered: true, size: 'lg' });
        } else {
          this.alertService.error(response.message);
        }
      }, error => {
        this.alertService.error('Ocorreu um erro ao obter recibo');
      }
    );
  }
}
